<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_08 col_12'><dynamic-field [id]='"scrntm"' [size]=8 [line]=1 [column]=12 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_29 col_26'><span class='brt high default' id='text1'>NRPC - STARS - TICKET INQUIRY</span>  </div>
  <div class='lgr_05 col_74'><span class='brt high default' id='text2'>S128G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_19 col_31'><span class='brt high default' id='text3'>PAYMENT INFORMATION</span>  </div>
  <div class='lgr_20 col_59'><dynamic-field [id]='"revnbr"' [size]=20 [line]=2 [column]=59 [(ngModel)]='revnbr'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_41 col_01'><span class='brt high default' id='text4'>PAYMT DT  REP  PRCSS DT    MONETARY ITEMS</span>  </div>
  <div class='lgr_29 col_46'><span class='brt high default' id='text5'>F O R M S  O F  P A Y M E N T</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_41 col_01'><span class='brt high default' id='text6'>  AGENT ID       REF #     TYPE    AMOUNT</span>  </div>
  <div class='lgr_29 col_46'><span class='brt high default' id='text7'>PC     AMOUNT  DEPENDENT DATA</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt1a"' [size]=79 [line]=7 [column]=1 [(ngModel)]='pymt1a'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt1b"' [size]=79 [line]=8 [column]=1 [(ngModel)]='pymt1b'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt1c"' [size]=79 [line]=9 [column]=1 [(ngModel)]='pymt1c'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt1d"' [size]=79 [line]=10 [column]=1 [(ngModel)]='pymt1d'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt1e"' [size]=79 [line]=11 [column]=1 [(ngModel)]='pymt1e'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt2a"' [size]=79 [line]=12 [column]=1 [(ngModel)]='pymt2a'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt2b"' [size]=79 [line]=13 [column]=1 [(ngModel)]='pymt2b'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt2c"' [size]=79 [line]=14 [column]=1 [(ngModel)]='pymt2c'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt2d"' [size]=79 [line]=15 [column]=1 [(ngModel)]='pymt2d'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt2e"' [size]=79 [line]=16 [column]=1 [(ngModel)]='pymt2e'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt3a"' [size]=79 [line]=17 [column]=1 [(ngModel)]='pymt3a'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt3b"' [size]=79 [line]=18 [column]=1 [(ngModel)]='pymt3b'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt3c"' [size]=79 [line]=19 [column]=1 [(ngModel)]='pymt3c'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt3d"' [size]=79 [line]=20 [column]=1 [(ngModel)]='pymt3d'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"pymt3e"' [size]=79 [line]=21 [column]=1 [(ngModel)]='pymt3e'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_03 col_07'><span class='brt high default' id='text8'>PF:</span>  </div>
  <div class='lgr_06 col_13'><span class='brt high default' id='text9'>4-EXIT</span>  </div>
  <div class='lgr_06 col_20'><span class='brt high default' id='text10'>3-MAIN</span>  </div>
  <div class='lgr_05 col_27'><dynamic-field [id]='"selmen"' [size]=5 [line]=23 [column]=27 [(ngModel)]='selmen'></dynamic-field></div>
  <div class='lgr_05 col_33'><span class='brt high default' id='text11'>5-ISS</span>  </div>
  <div class='lgr_06 col_39'><dynamic-field [id]='"prev"' [size]=6 [line]=23 [column]=39 [(ngModel)]='prev'></dynamic-field></div>
  <div class='lgr_06 col_46'><dynamic-field [id]='"next"' [size]=6 [line]=23 [column]=46 [(ngModel)]='next'></dynamic-field></div>
  <div class='lgr_08 col_53'><dynamic-field [id]='"coup"' [size]=8 [line]=23 [column]=53 [(ngModel)]='coup'></dynamic-field></div>
  <div class='lgr_08 col_62'><dynamic-field [id]='"usag"' [size]=8 [line]=23 [column]=62 [(ngModel)]='usag'></dynamic-field></div>
  <div class='lgr_08 col_71'><span class='brt high default' id='text12'>12-PRINT</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='brt high default' id='text13'>SHIFT PF:</span>  </div>
  <div class='lgr_12 col_11'><dynamic-field [id]='"currc1"' [size]=12 [line]=24 [column]=11 [(ngModel)]='currc1'></dynamic-field></div>
  <div class='lgr_17 col_25'><dynamic-field [id]='"prevc1"' [size]=17 [line]=24 [column]=25 [(ngModel)]='prevc1'></dynamic-field></div>
  <div class='lgr_08 col_55'><dynamic-field [id]='"last"' [size]=8 [line]=24 [column]=55 [(ngModel)]='last'></dynamic-field></div>
  <div class='lgr_09 col_65'><dynamic-field [id]='"first"' [size]=9 [line]=24 [column]=65 [(ngModel)]='first'></dynamic-field></div>
</div>
</div>
